// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../index';

import { EnquiryResponseNewCustomerFragmentDoc } from '../../../../components/enquiry/api/enquiryResponseNewCustomer.fragment.generated';
import { CustomerRegistrationResponseFragmentDoc } from '../../auth/fragments/customerRegistrationResponse.generated';
import { LoginResponseSuccessFragmentDoc } from '../../auth/fragments/loginResponseSuccess.generated';
import { MeFragmentDoc } from '../../fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../../fragments/costumerConsultant.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateDiamondSearchProductEnquiryNewCustomerDocument = `
    mutation createDiamondSearchProductEnquiryNewCustomer($input: EnquiryDiamondSearchProduct!, $customer: CustomerRegistrationInput!, $isConsultant: Boolean!) {
  createEnquiryDiamondSearchProductNewCustomer(input: $input, customer: $customer) {
    ...enquiryResponseNewCustomer
  }
}
    ${EnquiryResponseNewCustomerFragmentDoc}
${CustomerRegistrationResponseFragmentDoc}
${LoginResponseSuccessFragmentDoc}
${MeFragmentDoc}
${CostumerConsultantFragmentDoc}`;

export function useCreateDiamondSearchProductEnquiryNewCustomerMutation() {
  return Urql.useMutation<SchemaTypes.CreateDiamondSearchProductEnquiryNewCustomerMutation, SchemaTypes.CreateDiamondSearchProductEnquiryNewCustomerMutationVariables>(CreateDiamondSearchProductEnquiryNewCustomerDocument);
};